<template>
  <div>
    <h5 role="button" @click="open = !open">
      <i v-if="!open" class="fas fa-angle-right"></i>
      <i v-if="open" class="fas fa-angle-down"></i>
      {{ title }}
    </h5>
    <b-collapse v-model="open" ref="collapse">
      <ais-refinement-list
        :class-names="{
          'ais-RefinementList-showMore': 'btn btn-sm btn-primary'
        }"
        :attribute="attribute"
        :limit="10"
        :show-more="true"
        :show-more-limit="100"
        :transform-items="orderByResultsCount">
        <template
          v-slot="{
            items,
            isShowingMore,
            isFromSearch,
            canToggleShowMore,
            refine,
            createURL,
            toggleShowMore,
            searchForItems,
            sendEvent,
          }"
        >
          <ul class="ais-RefinementList-list">
            <li v-for="item in items" :key="item.value">
              <b-form-checkbox
                @input="refine(item.value)"
                :checked="item.isRefined"
              >
                <ais-highlight attribute="item" :hit="item"/>
                <span class="badge badge-pill badge-primary">{{ item.count.toLocaleString() }}</span>
              </b-form-checkbox>
            </li>
          </ul>
          <button
            v-if="canToggleShowMore"
            class="btn btn-sm btn-primary"
            @click="toggleShowMore"
          >
            {{ !isShowingMore ? 'Più risultati' : 'Meno risultati'}}
          </button>
        </template>
      </ais-refinement-list>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "StyledRefinementList",
  data() {
    return {
      open: false,
    }
  },
  props: {
    title: String,
    attribute: String
  },
  methods: {
    orderByResultsCount(items) {
      return items.sort((a, b) => {
        if (a.count > b.count) {
          return -1;
        }

        if (a.count < b.count) {
          return 1;
        }

        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }

        return 0
      });
    },
  }
}
</script>

<style scoped>

</style>
